module.exports = __webpack_public_path__ + "img/06.a38f9ce5.jpg";